import styled from "styled-components";

export const ErrorContainer = styled.div`
  padding: ${({ theme }) => theme.space.xxxl} ${({ theme }) => theme.space.md};
  text-align: center;
`;
